import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { isAdminEmail } from "../lib/adminService";

const ProtectedRoute = () => {
  const [user, loading] = useAuthState(auth);
  // null = not yet checked, true/false = allowlist result
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;

    if (!user) {
      setIsAdmin(null);
      return;
    }

    isAdminEmail(user.email).then(async (allowed) => {
      if (!active) return;
      if (!allowed) {
        // Authenticated but not an admin (e.g. an app user). Sign them
        // out so they are not left in a half-logged-in state.
        await signOut(auth);
      }
      if (active) setIsAdmin(allowed);
    });

    return () => {
      active = false;
    };
  }, [user]);

  // Wait for both the auth state and the allowlist check to resolve.
  if (loading || (user && isAdmin === null)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-t-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user || isAdmin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
